import React from 'react';
import styles from './expiry-date.module.scss';
import { useMyContentContext } from '../my-content.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { MS_PER_DAY } from 'shared/constants/date.constants';

export function ExpiryDate({ date }) {
  const { lang } = useMyContentContext();
  if (!date) return <div className={styles.date}>{lang.NEVER_EXPIRES}</div>;

  const expiryDate = new Date(date);
  const today = new Date();
  const diffTime = expiryDate - today;
  const diffDays = Math.ceil(diffTime / MS_PER_DAY);

  const isExpired = diffDays < 0;
  const formattedDate = expiryDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  if (isExpired) {
    return (
      <div className={styles.expired}>
        <div className={styles.date}>{formattedDate}</div>
        <p className={styles.status}>{lang.NO_LONGER_AVAILABLE}</p>
      </div>
    );
  }

  const getDaysText = days => {
    if (days === 0) return lang.EXPIRES_TODAY;
    return lang.DAYS_REMAINING.replace('{{days}}', days);
  };

  return (
    <div className={styles.expiryDate}>
      <div className={styles.date}>{formattedDate}</div>
      <p className={styles.remaining}>
        <FontAwesomeIcon icon={faClock} /> {getDaysText(diffDays)}
      </p>
    </div>
  );
}
